import React, { ReactNode, useEffect, useState } from 'react';
import Modal from '@common/modal';

import ProgressBar from '@components/progressBar';
import classnames from 'classnames/bind';
import styles from './stepModal.module.scss';
const cx = classnames.bind(styles);

interface StepSlide {
  leftContent: ReactNode;
  rightContent: ReactNode;
}

interface IStepModalProps {
  visible: boolean;
  onClose: () => void;
  onApply: (() => void) | (() => Promise<void>);
  stepSlideList: StepSlide[];
  nextBtnText?: string;
  prevBtnText?: string;
  applyBtnText?: string;
}

const StepModal = ({
  visible,
  onClose,
  onApply,
  stepSlideList,
  nextBtnText = '다음',
  prevBtnText = '이전',
  applyBtnText = '시작',
}: IStepModalProps) => {
  const [stepIndex, setStepIndex] = useState(0);
  const [isDisabledStartBtn, setIsDisabledStartBtn] = useState(false);

  const lastSlideIndex = stepSlideList.length - 1;
  const progress = ((stepIndex + 1) / (lastSlideIndex + 1)) * 100;

  const leftContentEl = stepSlideList[stepIndex].leftContent ?? <></>;
  const rightContentEl = stepSlideList[stepIndex].rightContent ?? <></>;

  const handlePrevStep = () => {
    if (stepIndex - 1 < 0) return;
    setStepIndex(stepIndex - 1);
  };

  const handleNextStep = () => {
    if (stepIndex + 1 > lastSlideIndex) return;
    setStepIndex(stepIndex + 1);
  };

  const onClickApplyBtn = () => {
    setIsDisabledStartBtn(true);
    onApply();
  };

  useEffect(() => {
    if (visible) {
      setIsDisabledStartBtn(false);
      setStepIndex(0);
    }
  }, [visible]);

  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <div className={cx('infoArea')}>
          <div className={cx('infoInner')}>{leftContentEl}</div>

          <div className={cx('btnArea')}>
            <ProgressBar progress={progress} className={cx('progressBar')} />

            {stepIndex > 0 && (
              <a className={cx('btnPrev')} role="button" onClick={handlePrevStep}>
                {prevBtnText}
              </a>
            )}
            {stepIndex === lastSlideIndex && (
              <button className={cx('btnNext')} onClick={onClickApplyBtn} disabled={isDisabledStartBtn}>
                {applyBtnText}
              </button>
            )}
            {stepIndex !== lastSlideIndex && (
              <a className={cx('btnNext')} role="button" onClick={handleNextStep}>
                {nextBtnText}
              </a>
            )}
          </div>
        </div>
        {rightContentEl}

        <a className={cx('btnClose')} onClick={onClose} role="button">
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default StepModal;
